import { app } from '../../../../../app';
import { Controller } from './assign-application.controller';

app.component('passwordAuthenticationPolicyAssignApplication', {
    bindings: {
        companyId: '<',
        defaultPolicy: '<',
        policy: '<',
    },
    controller: Controller,
    templateUrl: require('./assign-application.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/policies/password-authentication-policy/assign-application/assign-application.component.js